import { ROUTES } from '@/constants/routeConstants'
import { useAuthStore } from '@/store/auth'
import { Navigate } from '@tanstack/react-router'

export const RequireSignedIn = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const user = useAuthStore((s) => s.user)

  if (!user) {
    return <Navigate to={ROUTES.SIGN_IN} replace={true} />
  }

  return children
}
